import { render, staticRenderFns } from "./Turntable2.vue?vue&type=template&id=5b74bb8c&scoped=true&"
import script from "./Turntable2.vue?vue&type=script&lang=js&"
export * from "./Turntable2.vue?vue&type=script&lang=js&"
import style0 from "./Turntable2.vue?vue&type=style&index=0&id=5b74bb8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b74bb8c",
  null
  
)

export default component.exports